import * as React from "react";
import { FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { IUser } from "../../../App/Analytics/Common";
import Pagination from "../../utils/Pagination";

export interface IUsersProps {
  users: IUser[];
}

export const UserLink = styled(Link)`
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 0.5rem;
  cursor: pointer;

  color: inherit;
  text-decoration: inherit;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

export const UserName = styled.div`
  margin: 0 2rem;
`;

export class UsersPagination extends Pagination<IUser> {}

export const UserRow: React.SFC<{ user: IUser }> = props => (
  <UserLink to={``}>
    <FaUser />
    <UserName>{props.user.displayName}</UserName>
  </UserLink>
);
